import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // We wrap it in a micro-timeout to ensure the new route has fully mounted its DOM
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
